module.exports = __webpack_public_path__ + "media/images/icons/people-0a4862cc4df8a0d840852acbdc6c54aa.svg";